import { useEffect, useState } from "react";
import { Row, Col, Form, Container, FormGroup, Breadcrumb, Navbar, } from "react-bootstrap";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import { Link } from "react-router-dom";
import { getDateWiseOrderBilledReport } from "./Report.action";
import IconMenu from "../../../drawer/IconMenu";
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';


const DayWiseOrderBilledReport = (props) => {
  const [startDate, setStartDate] = useState(moment(new Date()).format("YYYY-MM-DD"));

  const exportPDF = () => {
    props.getDateWiseOrderBilledReport({ current_date: startDate });
  };

  useEffect(() => {
    props.getDateWiseOrderBilledReport({ current_date: startDate })
  }, []);
  return (
    <>
      <Navbar style={{ backgroundColor: '#81abd3' }}  >
        <Container>
          <Navbar.Brand style={{ color: 'white' }}><b>Day Wise OrderBilled Report </b></Navbar.Brand>
          <IconMenu />
        </Container>
      </Navbar>

      <Container fluid>
        <div className="main">
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item ><Link to="/home"> Home</Link></Breadcrumb.Item>
              <Breadcrumb.Item ><Link to="/report">Report</Link> </Breadcrumb.Item>
              <Breadcrumb.Item active>Day Wise OrderBilled Report</Breadcrumb.Item>
            </Breadcrumb>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Form.Label><b>Date *</b></Form.Label>
                <Form.Control
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                ></Form.Control>
              </FormGroup>
            </Col>
          </Row>

          <div className="sendDiv">
            {_.isEmpty(startDate) ? (
              <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> Generate Report </Button>
            ) : (
              <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={() => exportPDF()}> Generate Report </Button>
            )}
          </div>

        </div>
      </Container>

    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDateWiseOrderBilledReport: (data) => dispatch(getDateWiseOrderBilledReport(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  isFetchingOrderBilledReport: state.ReportReducer.isFetchingOrderBilledReport,
  orderBilledReportData: state.ReportReducer.orderBilledReportData,
});
export default connect(mapStateToProps, mapDispatchToProps)(DayWiseOrderBilledReport);